import callAPiBase from './base';

const attendancesApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/api/attendances',
      method: 'GET',
      useToken: true,
      params,
    }),
};

export { attendancesApi };
export default attendancesApi;
